import { render, staticRenderFns } from "./VideosField.vue?vue&type=template&id=c31cae72&scoped=true"
import script from "./VideosField.vue?vue&type=script&lang=ts"
export * from "./VideosField.vue?vue&type=script&lang=ts"
import style0 from "./VideosField.vue?vue&type=style&index=0&id=c31cae72&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c31cae72",
  null
  
)

export default component.exports